import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { getHistoricTelemetryByGroup } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  loadingTelemetryState,
  reportEndDateState,
  reportFilterGroupState,
  reportStartDateState,
  reportTelemetryState,
  reportTelemetryStates,
} from '../../../storage/reports';
import { HistoricTelemetry } from '../../../types/currentState';
import { TelemetryReportTable } from './TelemetryReportTable';

export function TelemetryReportsByGroup() {
  const { css } = useStyles();
  const groupId = useRecoilValue(reportFilterGroupState);
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const apiParams = useRecoilValue(apiParamsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const [loadingTelemetry, setLoadingTelemetry] = useRecoilState(loadingTelemetryState);
  const setReportHistorics = useSetRecoilState(reportTelemetryStates);
  const resetTelemetryHistorics = useResetRecoilState(reportTelemetryStates);
  const states = useRecoilValue(reportTelemetryState(groupId));

  useEffect(() => {
    return () => {
      resetTelemetryHistorics();
    };
  }, []);

  useEffect(() => {
    if (!groupId || !startDate || !endDate || !apiParams) return;

    const loadHistoricTelemetry = async () => {
      setLoadingTelemetry(true);
      const { historicTelemetry, error } = await getHistoricTelemetryByGroup(
        apiParams.clientId,
        groupId,
        startDate,
        endDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId
      );
      const newHistorics: { [key: string]: HistoricTelemetry[] } = {};
      if (!error) {
        newHistorics[groupId] = historicTelemetry ?? [];
      }
      setReportHistorics(newHistorics);
      setLoadingTelemetry(false);
    };

    loadHistoricTelemetry();
  }, [groupId, startDate, endDate]);

  if (loadingTelemetry) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <TelemetryReportTable
        states={states}
        extended
      />
    </FlexColumn>
  );
}
